module.exports = __webpack_public_path__ + "img/recolumn3.c514b3c9.png";